import { type MetaCategoryOverrideJson, type SrpMetaLegacyDetailsJson } from '@/types/seo'

export const createRobotsContent = (resultsCount: number) => {
  if (resultsCount === 0) {
    return { noindex: true, nofollow: true }
  }

  return { noindex: false, nofollow: false }
}

export const isMetaCategoryOverrideJson = (value: unknown): value is MetaCategoryOverrideJson =>
  !!(value as MetaCategoryOverrideJson)?.en.length &&
  !!(value as MetaCategoryOverrideJson)?.fr.length

export const isSrpLegacyMetaDetailsJson = (value: unknown): value is SrpMetaLegacyDetailsJson =>
  !!(value as SrpMetaLegacyDetailsJson)?.en.length &&
  !!(value as SrpMetaLegacyDetailsJson)?.fr.length
